import {EnvironmentType,} from '@models/system-vo/environment-type';
import {LogLevel,} from '@models/index';

// OFI AWS Dev(開発)環境のConfig
export const environment = {
  production: false,
  type: EnvironmentType.DEV,
  log_level: LogLevel.DEBUG,
  output_method_log: true,
  server_host: 'https://dev-lb.ivar-ofi.jp:8080',
  ignore_client_validation_for_testing: false,
  endpoint: {
    api: '/sms/api',
  },
};
